module.exports = __webpack_public_path__ + "img/knife_gypsy_jackknife.bc466c53.svg";